import React from 'react';
import { GraduationCap, Users, Instagram, ArrowUpRight } from 'lucide-react';
import { trackEvent } from '../lib/analytics';
import { mockData } from '../data/mock';
import { Novedades } from './Novedades';

export const Services = () => {
  return (
    <section id="services" className="py-11 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Actividades
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Participá de nuestras capacitaciones, visitas técnicas y eventos de networking diseñados para fortalecer tu empresa.
          </p>
        </div>

        {/* Featured Event Image */}
        <div className="mb-6 sm:mb-8 rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="/img/actividades.webp"
            alt="Presentación y capacitación en UIQ"
            className="w-full h-52 sm:h-96 object-cover"
            loading="lazy"
          />
        </div>

        {/* Services Overview */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
              <GraduationCap className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Formación Continua</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Ofrecemos talleres, seminarios y cursos especializados en gestión industrial, seguridad, comercio exterior, entre otros.
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                <span>Talleres de mejora continua</span>
              </li>
              <li className="flex items-start">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                <span>Cursos y capacitaciones de calidad</span>
              </li>
              <li className="flex items-start">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                <span>Seminarios de actualización normativa</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
              <Users className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Networking Industrial</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Facilitamos el encuentro entre empresarios, visitas técnicas y participación en ferias para expandir tu red de contactos.
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                <span>Rondas de negocios</span>
              </li>
              <li className="flex items-start">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                <span>Visitas a plantas industriales</span>
              </li>
              <li className="flex items-start">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                <span>Participación en exposiciones</span>
              </li>
            </ul>
          </div>
        </div>

        <Novedades />

        {/* Instagram: dónde se publican las actividades */}
        <div className="mt-6 sm:mt-8 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-800 text-white p-6 sm:p-8 lg:p-10 shadow-xl shadow-blue-600/20 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white/15 flex items-center justify-center flex-shrink-0">
            <Instagram className="w-8 h-8 sm:w-9 sm:h-9 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl sm:text-2xl font-bold mb-2">Mirá cómo fueron nuestros últimos encuentros</h3>
            <p className="text-blue-100 leading-relaxed">
              Fotos, novedades y próximas fechas para que no te pierdas ninguna.
            </p>
          </div>
          <a
            href="https://www.instagram.com/unionindustrialquilmes/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('click_instagram', { location: 'actividades' })}
            data-testid="actividades-instagram-btn"
            className="inline-flex items-center justify-center gap-2 bg-white text-blue-700 hover:bg-blue-50 font-semibold px-6 py-3.5 rounded-xl transition-all duration-300 hover:shadow-lg self-stretch md:self-auto md:whitespace-nowrap text-center"
          >
            <span className="sm:hidden">Seguinos en Instagram</span>
            <span className="hidden sm:inline">Seguinos en @unionindustrialquilmes</span>
            <ArrowUpRight className="w-4 h-4 flex-shrink-0" />
          </a>
        </div>
      </div>
    </section>
  );
};
